import { Vue, Component, Prop, Watch } from '@/utils';

@Component({
  name: 'select-field',
})
export class SelectField extends Vue {
  @Prop({type: [Number, String, Object]}) value;
  @Prop() items: any[];
  @Prop() itemText: string;
  @Prop() itemValue: string;
  @Prop() itemId: string;
  @Prop() title: string;
  @Prop({default: false}) field: boolean;
  @Prop({default: null}) placeholder: string;

  popupVisible = false;
  pickedText = null;

  get text() {
    if (this.value == null) {
      return null;
    }
    if (this.items && this.items.length) {
      for (const item of this.items) {
        const value = this.itemValue == null ? item : item[this.itemValue];
        if (this.value === value || (this.itemId != null && this.value[this.itemId] === value[this.itemId])) {
          return this.itemText == null ? item : item[this.itemText];
        }
      }
    }
    return null;
  }

  onClick() {
    this.popupVisible = true;
  }

  onPopupClick() {
  }

  onConfirm(value) {
    this.popupVisible = false;
    this.$emit('input', this.itemValue == null ? value : value[this.itemValue]);
  }

  onCancel() {
    this.popupVisible = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/select-field.ts